import React from 'react';

/**
 * UNA RIGA DI GIOCHI SENZA FINE: si scorre di lato e, arrivati all'ultimo
 * gioco, si ricomincia dal primo senza fermarsi (e all'indietro lo stesso).
 *
 * Come: i giochi sono scritti tre volte di fila e la riga parte dalla copia
 * di mezzo; appena si entra in quella di prima o di dopo, la riga torna di
 * una copia, nello stesso punto, e non si vede il salto. Le due copie in piu'
 * sono nascoste a chi legge lo schermo. Con pochi giochi, che stanno tutti
 * nella riga, non si ripete niente: non c'e' niente da scorrere.
 *
 * `figli` e' l'elenco dei giochi gia' disegnati, ognuno con la sua `key`.
 */
export default function RigaInfinita({figli, className, ...resto}) {
  const riga = React.useRef(null);
  const [ripeti, setRipeti] = React.useState(false);
  const n = figli.length;

  /* Si ripete solo se i giochi non stanno tutti nella riga: si misura la riga vera. */
  React.useLayoutEffect(() => {
    const el = riga.current;
    if (!el) return undefined;
    const misura = () => {
      const unaCopia = ripeti ? el.scrollWidth / 3 : el.scrollWidth;
      setRipeti(unaCopia > el.clientWidth + 8);
    };
    misura();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', misura);
      return () => window.removeEventListener('resize', misura);
    }
    const oss = new ResizeObserver(misura);
    oss.observe(el);
    return () => oss.disconnect();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [n, ripeti]);

  /* Quando le copie compaiono, si parte da quella di mezzo. */
  React.useLayoutEffect(() => {
    const el = riga.current;
    if (el && ripeti) el.scrollLeft = el.scrollWidth / 3;
  }, [ripeti, n]);

  const rimetti = () => {
    const el = riga.current;
    if (!el || !ripeti) return;
    const copia = el.scrollWidth / 3;
    if (el.scrollLeft < copia * 0.5) el.scrollLeft += copia;
    else if (el.scrollLeft > copia * 1.5) el.scrollLeft -= copia;
  };

  return (
    <div ref={riga} className={(className || '') + ' cas-infinita'} onScroll={rimetti} {...resto}>
      {ripeti
        ? (
          <>
            <div style={{display: 'contents'}} aria-hidden={'true'}>{figli}</div>
            <div style={{display: 'contents'}}>{figli}</div>
            <div style={{display: 'contents'}} aria-hidden={'true'}>{figli}</div>
          </>
        )
        : figli}
    </div>
  );
}
